import { Action } from '@ngrx/store'
import * as templatesTypes from './property-type-templates.types'
import { PropertyTypeTemplate } from './property-type-templates.interface'

export class FetchPropertyTypeTemplatesRequest implements Action {
  readonly type = templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchPropertyTypeTemplatesSuccess implements Action {
  readonly type = templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATES_SUCCESS
  constructor(
    public payload: PropertyTypeTemplate[],
    public filtered: number,
    public count: number,
  ) {}
}

export class FetchPropertyTypeTemplatesFailure implements Action {
  readonly type = templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATES_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyTypeTemplateRequest implements Action {
  readonly type = templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATE_REQUEST
  constructor(public id: number) {}
}

export class FetchPropertyTypeTemplateSuccess implements Action {
  readonly type = templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATE_SUCCESS
  constructor(public payload: PropertyTypeTemplate) {}
}

export class FetchPropertyTypeTemplateFailure implements Action {
  readonly type = templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class DeletePropertyTypeTemplateRequest implements Action {
  readonly type = templatesTypes.DELETE_PROPERTY_TYPE_TEMPLATE_REQUEST
  constructor(public id: number) {}
}

export class DeletePropertyTypeTemplateSuccess implements Action {
  readonly type = templatesTypes.DELETE_PROPERTY_TYPE_TEMPLATE_SUCCESS
  constructor() {}
}

export class DeletePropertyTypeTemplateFailure implements Action {
  readonly type = templatesTypes.DELETE_PROPERTY_TYPE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class CreatePropertyTypeTemplateRequest implements Action {
  readonly type = templatesTypes.CREATE_PROPERTY_TYPE_TEMPLATE_REQUEST
  constructor(public payload) {}
}

export class CreatePropertyTypeTemplateSuccess implements Action {
  readonly type = templatesTypes.CREATE_PROPERTY_TYPE_TEMPLATE_SUCCESS
  constructor() {}
}

export class CreatePropertyTypeTemplateFailure implements Action {
  readonly type = templatesTypes.CREATE_PROPERTY_TYPE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class UpdatePropertyTypeTemplateRequest implements Action {
  readonly type = templatesTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdatePropertyTypeTemplateSuccess implements Action {
  readonly type = templatesTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_SUCCESS
  constructor() {}
}

export class UpdatePropertyTypeTemplateFailure implements Action {
  readonly type = templatesTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = templatesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = templatesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdatePropertyTypeTemplateRequest
  | UpdatePropertyTypeTemplateSuccess
  | UpdatePropertyTypeTemplateFailure
  | FetchPropertyTypeTemplatesSuccess
  | FetchPropertyTypeTemplatesFailure
  | FetchPropertyTypeTemplatesRequest
  | FetchPropertyTypeTemplateSuccess
  | FetchPropertyTypeTemplateFailure
  | FetchPropertyTypeTemplateRequest
  | CreatePropertyTypeTemplateRequest
  | CreatePropertyTypeTemplateSuccess
  | CreatePropertyTypeTemplateFailure
  | DeletePropertyTypeTemplateRequest
  | DeletePropertyTypeTemplateSuccess
  | DeletePropertyTypeTemplateFailure
  | SetDefaultData
  | UpdateField
  | FetchPropertyTypeTemplatesRequest
  | FetchPropertyTypeTemplatesSuccess
  | FetchPropertyTypeTemplatesFailure
